// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// Styles
import './style.scss'

function Scrollable({ children, maxHeight, style, onScrollBottom, ...props }) {
  const onScroll = (e) => {
    const { scrollHeight, scrollTop, offsetHeight } = e.target

    if (offsetHeight + scrollTop >= scrollHeight - 2) {
      onScrollBottom()
    }
  }

  return (
    <div
      className="scroll-box"
      style={{ maxHeight, ...style }}
      onScroll={onScroll}
      {...props}
    >
      {children}
    </div>
  )
}

Scrollable.propTypes = {
  onScrollBottom: PropTypes.func,
  children: PropTypes.node,
  style: PropTypes.object,
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

Scrollable.defaultProps = {
  onScrollBottom: () => {},
  children: null,
  maxHeight: null,
  style: {},
}

export default Scrollable
